import _classCallCheck from "E:\\HariProjects\\a2z-frentend\\a2z-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "E:\\HariProjects\\a2z-frentend\\a2z-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "E:\\HariProjects\\a2z-frentend\\a2z-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "E:\\HariProjects\\a2z-frentend\\a2z-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _wrapNativeSuper from "E:\\HariProjects\\a2z-frentend\\a2z-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/wrapNativeSuper";
import * as React from 'react';
import { getGridCellElement, getGridColumnHeaderElement, getGridRowElement } from '../../../utils/domUtils';
import { GRID_ID_AUTOGENERATED } from './gridRowsUtils';
import { useGridApiMethod } from '../../utils/useGridApiMethod';
import { gridFocusCellSelector, gridTabIndexCellSelector } from '../focus/gridFocusStateSelector';
export var MissingRowIdError = /*#__PURE__*/function (_Error) {
  _inherits(MissingRowIdError, _Error);
  function MissingRowIdError() {
    _classCallCheck(this, MissingRowIdError);
    return _possibleConstructorReturn(this, _getPrototypeOf(MissingRowIdError).apply(this, arguments));
  }
  return MissingRowIdError;
}(_wrapNativeSuper(Error));

/**
 * @requires useGridColumns (method)
 * @requires useGridRows (method)
 * @requires useGridFocus (state)
 * @requires useGridEditing (method)
 * TODO: Impossible priority - useGridEditing also needs to be after useGridParamsApi
 * TODO: Impossible priority - useGridFocus also needs to be after useGridParamsApi
 */
export function useGridParamsApi(apiRef, props) {
  var getRowId = props.getRowId;
  var getColumnHeaderParams = React.useCallback(function (field) {
    return {
      field: field,
      colDef: apiRef.current.getColumn(field)
    };
  }, [apiRef]);
  var getRowParams = React.useCallback(function (id) {
    var row = apiRef.current.getRow(id);
    if (!row) {
      throw new MissingRowIdError("No row with id #".concat(id, " found"));
    }
    var params = {
      id: id,
      columns: apiRef.current.getAllColumns(),
      row: row
    };
    return params;
  }, [apiRef]);
  var getBaseCellParams = React.useCallback(function (id, field) {
    var row = apiRef.current.getRow(id);
    var rowNode = apiRef.current.getRowNode(id);
    if (!row || !rowNode) {
      throw new MissingRowIdError("No row with id #".concat(id, " found"));
    }
    var cellFocus = gridFocusCellSelector(apiRef);
    var cellTabIndex = gridTabIndexCellSelector(apiRef);
    var params = {
      id: id,
      field: field,
      row: row,
      rowNode: rowNode,
      value: row[field],
      colDef: apiRef.current.getColumn(field),
      cellMode: apiRef.current.getCellMode(id, field),
      api: apiRef.current,
      hasFocus: cellFocus !== null && cellFocus.field === field && cellFocus.id === id,
      tabIndex: cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === id ? 0 : -1
    };
    return params;
  }, [apiRef]);
  var getCellParams = React.useCallback(function (id, field) {
    var colDef = apiRef.current.getColumn(field);
    var value = apiRef.current.getCellValue(id, field);
    var row = apiRef.current.getRow(id);
    var rowNode = apiRef.current.getRowNode(id);
    if (!row || !rowNode) {
      throw new MissingRowIdError("No row with id #".concat(id, " found"));
    }
    var cellFocus = gridFocusCellSelector(apiRef);
    var cellTabIndex = gridTabIndexCellSelector(apiRef);
    var params = {
      id: id,
      field: field,
      row: row,
      rowNode: rowNode,
      colDef: colDef,
      cellMode: apiRef.current.getCellMode(id, field),
      hasFocus: cellFocus !== null && cellFocus.field === field && cellFocus.id === id,
      tabIndex: cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === id ? 0 : -1,
      value: value,
      formattedValue: value,
      isEditable: false
    };
    if (colDef && colDef.valueFormatter) {
      params.formattedValue = colDef.valueFormatter({
        id: id,
        field: params.field,
        value: params.value,
        api: apiRef.current
      });
    }
    params.isEditable = colDef && apiRef.current.isCellEditable(params);
    return params;
  }, [apiRef]);
  var getCellValue = React.useCallback(function (id, field) {
    var colDef = apiRef.current.getColumn(field);
    if (!colDef || !colDef.valueGetter) {
      var rowModel = apiRef.current.getRow(id);
      if (!rowModel) {
        throw new MissingRowIdError("No row with id #".concat(id, " found"));
      }
      return rowModel[field];
    }
    return colDef.valueGetter(getBaseCellParams(id, field));
  }, [apiRef, getBaseCellParams]);
  var getRowValue = React.useCallback(function (row, colDef) {
    var _getRowId;
    var id = GRID_ID_AUTOGENERATED in row ? row[GRID_ID_AUTOGENERATED] : (_getRowId = getRowId == null ? void 0 : getRowId(row)) != null ? _getRowId : row.id;
    var field = colDef.field;
    if (!colDef || !colDef.valueGetter) {
      return row[field];
    }
    return colDef.valueGetter(getBaseCellParams(id, field));
  }, [getBaseCellParams, getRowId]);
  var getRowFormattedValue = React.useCallback(function (row, colDef) {
    var _ref;
    var value = getRowValue(row, colDef);
    if (!colDef || !colDef.valueFormatter) {
      return value;
    }
    var id = (_ref = getRowId ? getRowId(row) : row.id) != null ? _ref : row[GRID_ID_AUTOGENERATED];
    var field = colDef.field;
    return colDef.valueFormatter({
      id: id,
      field: field,
      value: value,
      api: apiRef.current
    });
  }, [apiRef, getRowId, getRowValue]);
  var getColumnHeaderElement = React.useCallback(function (field) {
    if (!apiRef.current.rootElementRef.current) {
      return null;
    }
    return getGridColumnHeaderElement(apiRef.current.rootElementRef.current, field);
  }, [apiRef]);
  var getRowElement = React.useCallback(function (id) {
    if (!apiRef.current.rootElementRef.current) {
      return null;
    }
    return getGridRowElement(apiRef.current.rootElementRef.current, id);
  }, [apiRef]);
  var getCellElement = React.useCallback(function (id, field) {
    if (!apiRef.current.rootElementRef.current) {
      return null;
    }
    return getGridCellElement(apiRef.current.rootElementRef.current, {
      id: id,
      field: field
    });
  }, [apiRef]);
  var paramsApi = {
    getCellValue: getCellValue,
    getCellParams: getCellParams,
    getCellElement: getCellElement,
    getRowValue: getRowValue,
    getRowFormattedValue: getRowFormattedValue,
    getRowParams: getRowParams,
    getRowElement: getRowElement,
    getColumnHeaderParams: getColumnHeaderParams,
    getColumnHeaderElement: getColumnHeaderElement
  };
  useGridApiMethod(apiRef, paramsApi, 'public');
}